import config from '@/config';

/**
 * Предзаказ: у товара с активным предзаказом бэкенд отдаёт PREORDER_DELIVERY_FROM (Y-m-d) —
 * первую дату, с которой возможна доставка. После этой даты поле пустое и товар продаётся как обычный.
 * Предзаказ можно закрыть отдельно для СПб и Москвы (IS_PREORDER_CLOSED_SPB / IS_PREORDER_CLOSED_MSK).
 * Ожидает, что у компонента есть this.item.
 */
export default {
    computed: {
        preorderDeliveryFrom() {
            return this.item?.PREORDER_DELIVERY_FROM || null;
        },
        isPreorder() {
            return !!this.preorderDeliveryFrom;
        },
        // предзаказ закрыт для города, выбранного в шапке; для другого города - только если закрыт в обоих регионах
        isPreorderClosed() {
            if (!this.isPreorder) return false;

            const city = this.$store.state.cityName; // как в mixins/city.js
            const isClosedSpb = !!this.item.IS_PREORDER_CLOSED_SPB;
            const isClosedMsk = !!this.item.IS_PREORDER_CLOSED_MSK;

            if (city === config.CITIES[0].name) return isClosedSpb;
            if (city === config.CITIES[1].name) return isClosedMsk;
            return isClosedSpb && isClosedMsk;
        },
        addToBasketLabel() {
            if (!this.isPreorder) return 'В корзину';
            return this.isPreorderClosed ? 'Предзаказ закрыт' : 'Предзаказ';
        },
    },
};
